import { render, staticRenderFns } from "./NsOktaPassword.vue?vue&type=template&id=c6a54428&scoped=true&"
import script from "./NsOktaPassword.vue?vue&type=script&lang=js&"
export * from "./NsOktaPassword.vue?vue&type=script&lang=js&"
import style0 from "./NsOktaPassword.vue?vue&type=style&index=0&id=c6a54428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a54428",
  null
  
)

export default component.exports